import { regex } from 'react-admin'

import { TValidator } from './validators'

export const pattern =
  (regExpStr: string): TValidator<string> =>
  (value, values) => {
    const regExp = safeBuildUnicodeRegExp(regExpStr)
    if (!(regExp instanceof RegExp)) return

    return regex(regExp)(value ?? '', values)
  }

const safeBuildUnicodeRegExp = (regExpStr: string): RegExp | null => {
  try {
    return new RegExp(regExpStr, 'u')
  } catch (e) {
    console.warn(`Unsupported RegExp: "${regExpStr}"`, e)
  }

  return null
}
